module.exports = {
      id: "comm-women-usage",
      viewBox: "0 0 228.124 50.336",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-women",
      toString: function () {
        return this.url;
      }
    }